<div class="wrapper">
  <button
    class="entry-button"
    themeColor="primary"
    (click)="onEntryButtonClick()">
    <span class="k-icon k-font-icon k-i-track-changes-accept entry"></span>
  </button>
</div>
